import React from "react";
import { withRouter, Link } from "react-router-dom";

import "./Navbar.css";
const Navbar = props => {
  console.log(props);
  let { pathname } = props.location;
  if (pathname === "/") return null;
  return (
    <div className="navigation">
      <Link to="/" className="logo">
        Aayush
      </Link>
      <div className="nav-grid-wrapper">
        <Link to="/works" className="">
          <span className={pathname === "/works" ? "active" : null}>Works</span>
        </Link>

        <Link to="/skills" className="">
          <span className={pathname === "/skills" ? "active" : null}>
            Skills
          </span>
        </Link>

        <Link to="/contact" >
          <span className={pathname === "/contact" ? "active" : null}>
            Contact
          </span>
        </Link>
      </div>
    </div>
  );
};

export default withRouter(Navbar);
